import { render, staticRenderFns } from "./templateEditor.vue?vue&type=template&id=263cd52b&scoped=true&"
import script from "./templateEditor.vue?vue&type=script&lang=js&"
export * from "./templateEditor.vue?vue&type=script&lang=js&"
import style0 from "./templateEditor.vue?vue&type=style&index=0&id=263cd52b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263cd52b",
  null
  
)

export default component.exports